// react
import { FormEvent } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Button, Grid, Paper, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// icons
import { theme } from '../../../../../../theme';

// ui
import { Filters, FilterProps } from '../../../../../ui/Filters/Filters';

export interface SoeFiltersProps {
	filters: FilterProps[];
	isLoading?: boolean;
	onSubmit?: (e: FormEvent) => void;
	onReset?: () => void;
}

export const SoeFilters = ({ filters, isLoading = false, onSubmit, onReset }: SoeFiltersProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Paper
			sx={(theme) => {
				return {
					padding: theme.spacing(2),
					[theme.breakpoints.up('md')]: {
						padding: theme.spacing(3),
					},
					height: '100%',
				};
			}}>
			<form id="form-soe-filters" onSubmit={onSubmit} name="formSoeFilters">
				<Grid container spacing={theme.spacing(2)}>
					<Grid item xs={12}>
						<Typography variant="h3">{t('filters')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<Filters filters={filters} isLoading={isLoading} />
					</Grid>
					<Grid item xs={12}>
						<Grid container justifyContent="flex-end" spacing={2}>
							<Grid item>
								<LoadingButton
									color="primary"
									disabled={isLoading}
									fullWidth
									loading={isLoading}
									type="submit"
									variant="contained">
									{t('generateReport')}
								</LoadingButton>
							</Grid>
							<Grid item>
								<Button fullWidth variant="outlined" onClick={onReset}>
									{t('reset')}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</form>
		</Paper>
	);
};
